"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (date, arr) => {
    return arr.find((t) => t.date === date);
};
//# sourceMappingURL=findDate.js.map